// see node_modules/react-laag/dist/PlacementType.d.ts
var Placements;
(function (Placements) {
  Placements["BottomCenter"] = 'bottom-center';
  Placements["BottomEnd"] = 'bottom-end';
  Placements["BottomStart"] = 'bottom-start';
  Placements["Center"] = 'center';
  Placements["LeftCenter"] = 'left-center';
  Placements["LeftEnd"] = 'left-end';
  Placements["LeftStart"] = 'left-start';
  Placements["RightCenter"] = 'right-center';
  Placements["RightEnd"] = 'right-end';
  Placements["RightStart"] = 'right-start';
  Placements["TopCenter"] = 'top-center';
  Placements["TopEnd"] = 'top-end';
  Placements["TopStart"] = 'top-start';
})(Placements || (Placements = {}));
export { Placements };